module.exports = {"411171101":"后谢镇","411171102":"邓襄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411171.json
// module id = 1751
// module chunks = 0